import React from 'react';
import { Outlet } from 'react-router';

import { useRedirectLayout } from 'hooks/useRedirectLayout';
import { ROUTES } from 'routes/config/constants';
import { CLIENTS_CHILDREN } from 'routes/config/routesChildren/clients';

const ClientsLayout = () => {
  useRedirectLayout(ROUTES.CLIENTS_MANAGEMENT.PATH, CLIENTS_CHILDREN);

  return <Outlet />;
};

export default ClientsLayout;
